export default "__VITE_ASSET__C7JCNSo5__"